if (!customElements.get('product-form')) {
  customElements.define(
    'product-form',
    class ProductForm extends HTMLElement {
      constructor() {
        super();

        this.form = this.querySelector('form');
        this.variantIdInput.disabled = false;
        this.form.addEventListener('submit', this.onSubmitHandler.bind(this));
        this.cart = document.querySelector('cart-notification') || document.querySelector('cart-drawer');
        this.submitButton = this.querySelector('[type="submit"]');

        this.submitButtonText = this.submitButton.querySelector('span');

        if (document.querySelector('cart-drawer')) this.submitButton.setAttribute('aria-haspopup', 'dialog');

        this.hideErrors = this.dataset.hideErrors === 'true';
      }

      async onSubmitHandler(evt) {
        evt.preventDefault();
        

				const bubble = document.querySelector('cart-drawer .drawer__heading .total_items');
				bubble.classList.remove('show');

        if (this.submitButton.getAttribute('aria-disabled') === 'true') return;
        const soldOutButton = this.submitButton.querySelector('.custom_button.sold_out');

        if (soldOutButton && !soldOutButton.classList.contains('hide')) {
          return;
        }

        this.handleErrorMessage();

        this.submitButton.setAttribute('aria-disabled', true);
        this.submitButton.classList.add('loading');
        this.querySelector('.loading__spinner').classList.remove('hidden');

        const config = fetchConfig('javascript');

        config.headers['X-Requested-With'] = 'XMLHttpRequest';
        delete config.headers['Content-Type'];

        const formData = new FormData(this.form);
        
        if (this.cart) {
          formData.append(
            'sections',
            this.cart.getSectionsToRender().map((section) => section.id)
          );
          formData.append('sections_url', window.location.pathname);
          this.cart.setActiveElement(document.activeElement);
        }

        config.body = formData;
				
				try{
					const url = `${routes.cart_add_url}`;
					const response = await fetch(url, config);

					const res = await response.json();

					if(res.status === 422) return;

					if(res.status) {

						publish(PUB_SUB_EVENTS.cartError, {
							source: 'product-form',
							productVariantId: formData.get('id'),
							errors: response.errors || response.description,
							message: response.message,
						});

						this.handleErrorMessage(response.description);

						const soldOutMessage = this.submitButton.querySelector('.sold-out-message');
						if (!soldOutMessage) return;
						this.submitButton.setAttribute('aria-disabled', true);
						this.submitButtonText.classList.add('hidden');
						soldOutMessage.classList.remove('hidden');
						this.error = true;
					} else if (!this.cart) {
						window.location = window.routes.cart_url;
					}
					
					const quickAddModal = this.closest('quick-add-modal');
					if (quickAddModal) {
						document.body.addEventListener(
							'modalClosed',
							() => {
							},
							{ once: true }
						);
						quickAddModal.hide(true);
					}

					this.submitButton.classList.remove('loading');
					if (this.cart && this.cart.classList.contains('is-empty')) this.cart.classList.remove('is-empty');
					if (!this.error) this.submitButton.removeAttribute('aria-disabled');
					this.querySelector('.loading__spinner').classList.add('hidden');


          window.prescriptionModal && window.prescriptionModal.init();
					sessionStorage.setItem('cartChanged', 'true');

				} catch (error) {
					console.log('onSubmitHandler error', error);
					return error;
				}
      }

      handleErrorMessage(errorMessage = false) {
        if (this.hideErrors) return;

        this.errorMessageWrapper =
          this.errorMessageWrapper || this.querySelector('.product-form__error-message-wrapper');
        if (!this.errorMessageWrapper) return;
        this.errorMessage = this.errorMessage || this.errorMessageWrapper.querySelector('.product-form__error-message');

        this.errorMessageWrapper.toggleAttribute('hidden', !errorMessage);

        if (errorMessage) {
          this.errorMessage.textContent = errorMessage;
        }
      }

      toggleSubmitButton(disable = true, text) {
        if (disable) {
          this.submitButton.setAttribute('disabled', 'disabled');
          if (text) this.submitButtonText.textContent = text;
        } else {
          this.submitButton.removeAttribute('disabled');
          this.submitButtonText.textContent = window.variantStrings.addToCart;
        }
      }

      get variantIdInput() {
        return this.form.querySelector('[name=id]');
      }
    }
  );
}

function changeShippingLine() {
  const parentHeader = document.querySelector('horizontal-borders .content_header');
  const parentBody = document.querySelector('horizontal-borders .content_body');

  if (!parentHeader && !parentBody) return;

  const shippingHeaderPrice = parentHeader.querySelectorAll('.title.shipping .header_price');
  let shippingUsSpend = parentBody.dataset.shippingUsSpend;
  let shippingInternationalSpend = parentBody.dataset.shippingInternationalSpend;
  const shippingSpendIcon = parentBody.querySelector('.us-shipping');
  const shippingSpendLine = parentBody.querySelector('.us-shipping .line_box span');

  if (!shippingSpendLine) return;
  fetch('/cart.js')
    .then((response) => response.json())
    .then((data) => {
      const localization = this.getCookie('localization');
      if (!localization) return;

      showHideFreeHeader(localization);

      const spend =
        localization === 'US'
          ? this.splitStringPrice(shippingUsSpend)
          : this.splitStringPrice(shippingInternationalSpend);

      const rate = +Shopify.currency.rate;

      // const width = data['total_price'] * 100 / +spend;
      const width = 50;

      shippingSpendLine.style.width = `${width}%`;


      if (data['total_price'] >= +spend) {
        shippingSpendLine.style.width = `100%`;
        shippingSpendIcon.classList.add('full');
      }

      if (data['total_price'] < +spend) {
        shippingHeaderPrice.forEach((item) => {
          const priceCurrency = this.splitPrice(item.dataset.shippingPrice);
          item.textContent = `${priceCurrency.currency}${((+spend - data['total_price']) / 100).toFixed(2)}`;
        });
      }
    });
}
